import React from "react";
import { Box, Button, Grid, Paper, Container, useMediaQuery, useTheme } from "@mui/material";
import { styled } from "@mui/system";
import IPDCFormHeader from "./IPDCFormHeader";

//prettier-ignore
const FormWrapper = styled(Paper)(({ theme }) => (
  {
    padding: theme.spacing(4), 
    width: "100%", 
    maxWidth: 1600,
    margin: "0 auto",
    [theme.breakpoints.up('xl')]: {
      maxWidth: 1800,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 1600,
    },
    [theme.breakpoints.down('lg')]: {
      maxWidth: '95%',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '95%',
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      padding: theme.spacing(2),
    }
  }
));

//prettier-ignore
const FormContainer = ({ 
  title, 
  children, 
  onSubmit, 
  showButton = true, 
  buttonLabel = "Register", 
  showTitle = true, 
  extraInfoAfterButton = null,
  maxWidth = 1600,
  fullWidth = false
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const wrapperStyle = fullWidth ? {
    maxWidth: '100% !important',
    width: '100%'
  } : {};

  return (
    <Container 
      sx={{ 
        width: "100%", 
        height: isSmallScreen ? "auto" : "60%", 
        alignItems: "center", 
        mt: 1,
        px: { xs: 1, sm: 2, md: 3 },
        maxWidth: '100% !important'
      }} 
      maxWidth={false}
    >
      <FormWrapper elevation={3} sx={wrapperStyle}>
        <Box component="form" onSubmit={onSubmit}>
          {/* Changed spacing to 3 and added pl: 2 to match code 2 */}
          <Grid container spacing={3} sx={{ pl: 2 }}>
            {showTitle && (
              <Grid item xs={12}>
                <IPDCFormHeader title={title} />
              </Grid>
            )}
            {children}
            {showButton && (
              <Grid item xs={12}>
                {/* Added gap: 2 to match code 2's button container */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                  <Button 
                    variant="contained" 
                    type="submit"
                    size="medium"
                    sx={{ 
                      py: 1,
                      px: 3,
                      fontSize: '1rem',
                      minWidth: '120px',
                      width: 'auto',
                      textTransform: 'none',
                      backgroundColor: '#e0e0e0',
                      color: '#000000',
                      '&:hover': {
                        backgroundColor: '#d5d5d5', // Changed to match code 2
                      }
                    }}
                  >
                    {buttonLabel}
                  </Button>
                </Box>
              </Grid>
            )}
            {extraInfoAfterButton && (
              <Grid item xs={12}>
                {extraInfoAfterButton}
              </Grid>
            )}
          </Grid>
        </Box>
      </FormWrapper>
    </Container>
  );
};

export default FormContainer;